/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { File } from '../../models/file';

export interface ExportMeetDayStudents$Params {
  meetDayId: string;
}

export function exportMeetDayStudents(http: HttpClient, rootUrl: string, params: ExportMeetDayStudents$Params, context?: HttpContext): Observable<StrictHttpResponse<File>> {
  const rb = new RequestBuilder(rootUrl, exportMeetDayStudents.PATH, 'get');
  if (params) {
    rb.path('meetDayId', params.meetDayId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<File>;
    })
  );
}

exportMeetDayStudents.PATH = '/meetday/{meetDayId}/student/export';
